<template>
  <div class="pv-gallery-zoom-carousel js-product-gallery-zoom-carousel">
    <!-- Teleport Content -->
    <div
      v-if="shouldIncludeFirstSlide"
      id="pvGalleryFirstSlide"
      class="pv-gallery-zoom-carousel__cell js-product-gallery-zoom-carousel-cell"
      data-cell-index="0"
    >
      <!-- Teleport content will be dynamically inserted here -->
    </div>

    <!-- Current Variant Featured Image -->
    <div
      v-if="currentVariant.featured_media"
      class="pv-gallery-zoom-carousel__cell js-product-gallery-zoom-carousel-cell"
      :data-cell-index="shouldIncludeFirstSlide ? 1 : 0"
    >
      <ResponsiveImage
        :image="currentVariant.featured_media.preview_image?.src || currentVariant.featured_media.src"
        :image-alt="currentVariant.featured_media.alt"
        :wrapper-class="'pv-gallery-zoom-carousel__media pv-gallery-zoom-carousel__media--image'"
      />
    </div>

    <!-- Current Variant Metafields Media Assets -->
    <div
      v-for="(image, index) in secondaryImages"
      :key="`secondary-${index}`"
      class="pv-gallery-zoom-carousel__cell js-product-gallery-zoom-carousel-cell"
      :data-cell-index="(shouldIncludeFirstSlide ? 2 : 1) + index"
    >
      <ResponsiveImage
        :image="image.preview_image?.src || image.src"
        :image-alt="image.alt"
        :wrapper-class="'pv-gallery-zoom-carousel__media pv-gallery-zoom-carousel__media--image'"
      />
    </div>

    <!-- Product Images Not Used as Featured Images -->
    <div
      v-for="(media, index) in tertiaryImages"
      :key="`tertiary-${index}`"
      class="pv-gallery-zoom-carousel__cell js-product-gallery-zoom-carousel-cell"
      :data-cell-index="(shouldIncludeFirstSlide ? 2 : 1) + secondaryImages.length + index"
    >
      <ResponsiveImage
        :image="media.preview_image?.src || media.src"
        :image-alt="media.alt"
        :wrapper-class="'pv-gallery-zoom-carousel__media pv-gallery-zoom-carousel__media--image'"
      />
    </div>
  </div>
</template>

<script>
import ResponsiveImage from '../common/responsive-image/ResponsiveImage';

export default {
  name: 'ProductGalleryZoomCart',
  components: {
    ResponsiveImage,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    currentVariant: {
      type: Object,
      required: true,
    },
    shouldIncludeFirstSlide: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    secondaryImages() {
      // Current variant's metafields media_assets
      return this.currentVariant.metafields?.media_assets || [];
    },
    tertiaryImages() {
      // Product images not used as featured images for any variant
      const featuredMediaIds = this.product.variants
        .map((variant) => variant.featured_media?.id)
        .filter(Boolean);

      return this.product.media.filter((media) => {
        return (
          !featuredMediaIds.includes(media.id) &&
          media.id !== this.currentVariant.featured_media?.id &&
          !this.secondaryImages.some((image) => image.id === media.id)
        );
      });
    },
  },
};
</script>
